import React from 'react';
import { formatColaMedicaTooltip, getColaMedicaMeta } from '../utils/pedidoColaMedica';

/**
 * Indicador de tiempo en cola (verde <24h · naranja 2–3d · rojo resto).
 */
export default function ColaMedicaBadge({ pedido, nowMs = Date.now(), variant = 'chip', compact = false }) {
  const meta = getColaMedicaMeta(pedido, nowMs);
  const title = formatColaMedicaTooltip(pedido, nowMs);
  const tierClass = `crm-cola-wait crm-cola-wait--${meta.tier}${compact ? ' crm-cola-wait--compact' : ''}`;

  if (variant === 'inline') {
    return (
      <span title={title} className={tierClass}>
        <span className="crm-cola-wait__dot" aria-hidden />
        <span className="crm-cola-wait__line">
          <span className="crm-cola-wait__duration">{meta.durationLabel}</span>
          {meta.showTierLabel ? (
            <span className="crm-cola-wait__tier">· {meta.tierLabel}</span>
          ) : null}
        </span>
      </span>
    );
  }

  return (
    <div title={title} className={`${tierClass} crm-cola-wait--chip`}>
      <span className="crm-cola-wait__dot" aria-hidden />
      <div className="crm-cola-wait__stack">
        <div className="crm-cola-wait__duration">{meta.durationLabel}</div>
        {meta.showTierLabel ? (
          <div className="crm-cola-wait__tier-line">
            {meta.tierLabel}
            {meta.slaBreached && meta.tier === 'critical' ? ' · superó 24 h' : ''}
          </div>
        ) : null}
      </div>
    </div>
  );
}
